import { createFileRoute } from '@tanstack/react-router'

// The leaf that makes the pathless `_timeline` layout match on bare `/admin/sessions/$sessionId`.
export const Route = createFileRoute('/_app/admin/sessions_/$sessionId/_timeline/')({})
